export const a11yProps = (index) => ({
  id: `dn-tab-${index}`,
  'aria-controls': `dn-tabpanel-${index}`,
});
